const model = {
  text: null,
  category: null
};

const fields = [
  {
    path: "text",
    type: "text",
    label: "Value"
  }
];

const tableFields = [
  {
    key: "text",
    label: "Preference",
    sortable: true
  }
];

const info = {
  id: "preferences",
  db: "preferences",
  name: "Preferences",
  single: "Preference",
  fields: tableFields
};

export {model, fields, info};
